import React from 'react';

const Separator = () => {
  return <div className="toolbar-separator" />;
};

export default Separator;
